import { gql } from "@apollo/client";
import CommentFields from "~/lib/queries/fragments/CommentFields";

export default gql`
  mutation CreateComment($targetId: ObjectId!, $targetType: CommentTargetType!, $body: JSON!) {
    createComment(targetType: $targetType, targetId: $targetId, body: $body) {
      _id
      ...CommentFieldsLegacy
    }
  }

  ${CommentFields}
`;
